import React, { ReactNode, useMemo, useState } from 'react'
import ResponsiveSwiper, {
  ResponsiveConfig,
} from 'Components/new/responsive-swiper'
import SwiperButton from 'Components/swiper-button'
import classNames from 'classnames'

interface IProps {
  title: ReactNode
  smCols: number
  smRows: number
  slideCount: number
  slideClass: string
  gap?: number
  children(params: { index: number; activeIndex: number }): ReactNode
  className?: string
}

const HotLayout = ({
  title,
  smCols,
  smRows,
  slideCount,
  slideClass,
  gap,
  children,
  className,
}: IProps) => {
  const cols = useMemo<ResponsiveConfig>(() => {
    return {
      sm: smCols,
      md: 1,
      lg: 1,
      xl: 1,
      '2xl': 1,
    }
  }, [smCols])
  const rows = useMemo<ResponsiveConfig>(() => {
    return {
      sm: smRows,
      md: slideCount,
      lg: slideCount,
      xl: slideCount,
      '2xl': slideCount,
    }
  }, [smRows, slideCount])

  const [prevEl, setPrevEl] = useState<HTMLElement | null>()
  const [nextEl, setNextEl] = useState<HTMLElement | null>()

  const hasButton = slideCount > smCols * smRows

  return slideCount ? (
    <React.Fragment>
      <div className={className}>
        <div
          className={classNames('tw-relative', {
            'tw-pr-64 md:tw-pr-0': hasButton,
          })}
        >
          {title}
          {hasButton && (
            <div className="md:tw-hidden">
              <SwiperButton
                type="prev"
                ref={setPrevEl}
                className="swiper-button-disabled"
                theme={'gray'}
                buttonStyle={{
                  position: 'absolute',
                  right: '28px',
                  top: '10px',
                }}
              />
              <SwiperButton
                type="next"
                ref={setNextEl}
                theme={'gray'}
                buttonStyle={{
                  position: 'absolute',
                  right: '-6px',
                  top: '10px',
                }}
              />
            </div>
          )}
        </div>
        <ResponsiveSwiper
          slideCount={slideCount}
          cols={cols}
          slideClass={slideClass}
          gap={gap}
          rows={rows}
          navigation={{
            prevEl,
            nextEl,
          }}
        >
          {children}
        </ResponsiveSwiper>
      </div>
      <style jsx>
        {`
          :global(.hot-talk-wrapper a) {
            display: block;
            height: 100%;
          }
        `}
      </style>
    </React.Fragment>
  ) : null
}

export default HotLayout
